<div class="card-placeholder table-comp w-100">
  <div class="card-body placeholder-glow">
    <div class="card-title mb-2">
      <span class="placeholder col-4 placeholder-lg p-3"></span>
    </div>
    <div class="card-text mb-3 p-3">
      <div>
        <span class="placeholder col-12 p-3"></span>
      </div>
      <div>
        <span class="placeholder col-3 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
      </div>
      <div>
        <span class="placeholder col-3 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
      </div>
      <div>
        <span class="placeholder col-3 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
        <span class="placeholder col-4 me-1"></span>
      </div>
    </div>
  </div>
  @if (displayButton) {
    <div class="d-flex justify-content-end w-100">
      <button class="mwp-button" [disabled]="true">Loading</button>
    </div>
  }

</div>